/**
 * The orgs an agency may assign as a project's client:
 * - a partner agency: its own client orgs (Accounts parentOrgId), nothing else;
 * - Solid Digital: every other org except partner agencies and their clients.
 * The API enforces the partner rule too; this keeps the picker honest.
 */
export function assignableClientOrgs<T extends { id: string; kind?: string | null; parentOrgId?: string | null }>(
  orgs: T[],
  agencyOrg: { id: string; type: string } | undefined,
): T[] {
  if (!agencyOrg) return [];
  if (agencyOrg.type === 'PARTNER') return orgs.filter((org) => org.parentOrgId === agencyOrg.id);
  return orgs.filter(
    (org) =>
      org.id !== agencyOrg.id &&
      org.kind !== 'AGENCY' &&
      (!org.parentOrgId || org.parentOrgId === agencyOrg.id),
  );
}
